import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { Instagram, Youtube, Music2 } from 'lucide-react';
import { FAN_PAGES, formatNum } from '../data';

const PlatformIcon = ({ platform, size = 16 }) => {
    if (platform === 'Instagram') return <Instagram size={size} />;
    if (platform === 'YouTube') return <Youtube size={size} />;
    if (platform === 'TikTok') return <Music2 size={size} />;
    return null;
};

const platformAccent = (platform) => {
    if (platform === 'Instagram') return 'bg-pink-500/15 text-pink-300';
    if (platform === 'YouTube') return 'bg-red-500/15 text-red-300';
    if (platform === 'TikTok') return 'bg-cyan-500/15 text-cyan-300';
    return 'bg-white/10 text-white/70';
};

const FanCard = ({ entry }) => {
    return (
        <GlassCard>
            <div className="flex items-center justify-between mb-4">
                <p className="text-white font-bold text-sm tracking-tight">{entry.persona}</p>
                <div className={`${platformAccent(entry.platform)} px-2.5 py-1 rounded-full inline-flex items-center gap-1.5`}>
                    <PlatformIcon platform={entry.platform} size={12} />
                    <span className="text-[10px] font-bold uppercase tracking-wider">{entry.platform}</span>
                </div>
            </div>

            <p className="text-white/40 text-xs font-mono mb-5 truncate">{entry.handle}</p>

            <div className="grid grid-cols-3 gap-2">
                <div>
                    <p className="text-white/40 text-[9px] uppercase tracking-widest font-semibold mb-1">Followers</p>
                    <p className="text-base font-black text-white tracking-tight">{formatNum(entry.followers)}</p>
                </div>
                <div>
                    <p className="text-white/40 text-[9px] uppercase tracking-widest font-semibold mb-1">Posts</p>
                    <p className="text-base font-black text-white tracking-tight">{formatNum(entry.posts)}</p>
                </div>
                <div>
                    <p className="text-white/40 text-[9px] uppercase tracking-widest font-semibold mb-1">Views</p>
                    <p className="text-base font-black text-white tracking-tight">{formatNum(entry.views)}</p>
                    {entry.stale && (
                        <span className="inline-flex mt-1 bg-amber-500/15 text-amber-300 text-[8px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap">
                            as of May 13
                        </span>
                    )}
                </div>
            </div>
        </GlassCard>
    );
};

export const FanPageGrid = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-6xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">Fan Pages</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">
                    The Network Map
                </h2>
                <p className="text-white/50 text-center mb-12 max-w-xl mx-auto">
                    9 fan accounts. 3 personas × 3 platforms. All feeding back to the main page.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {FAN_PAGES.map((entry, i) => (
                        <FanCard key={i} entry={entry} />
                    ))}
                </div>
            </div>
        </section>
    );
};
